import { lazy } from 'react';
import store from 'src/redux/config/configureStore';
import template from 'lodash/template';
import * as en from 'src/lang/en.json';
import * as heb from 'src/lang/heb.json';

const langsMap = {
  en,
  heb,
};
class I18nService {
  /**
   * Translates a key into a string based on the selected language
   * and the dictionary.
   */
  translate(key: string, args?: Record<string, any>, lang: string = 'en') {
    const { languageContext } = store.getState().general;
    const dictionary: any =
      langsMap[languageContext.language || lang]['default'];
    if (key === undefined) return ''; // Check if can DELETE
    // const translation = dictionary[key] ? dictionary[key] : null;
    const translation = key.split('.').reduce((res, currentKey) => {
      if (!res) res = dictionary;
      return (res = res[currentKey]);
    }, '');
    if (!translation || typeof translation != 'string') {
      return key;
    }
    return template(translation)(args || {});
  }
}

export const i18nService = new I18nService();
